<template>
  <div>
      <!-- Pastille d'information -->
      <div class="row">
        
              <!-- ================================================================= -->
              <!-- Section d'affichage des transactions des abonnements de l'organisation -->
              <!-- ================================================================= -->
            <div class="col-sm-12 col-md-12">
              <div class="block block-themed block-bordered">
                <div class="block-header bg-primary-dark">
                      <ul class="block-options">
                          <li v-if="flagDisplaySectionApi===0">
                              <button type="button" @click="toggleDisplayApi()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                          </li>
                          <li v-if="flagDisplaySectionApi">
                              <button  type="button" @click="toggleDisplayApi()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                          </li>
                      </ul>
                  <h2 class="block-title" @click="toggleDisplayApi()">{{ sectionLabelApiManagement[actualLanguage] }}</h2>
                </div>

                <div v-if="flagDisplaySectionApi" class="block-content">
                    <!-- ================================================================= -->
                    <!-- Section documentation-->
                    <!-- ================================================================= -->
                    <div class="row">

                        <!-- Full Table -->
                          <div class="block block-bordered">
                              <div class="block-header bg-gray">
                                  <h3 class="block-title" @click="toggleDisplayDocument()">{{DocumentTableTitle[actualLanguage]}}</h3>
                              </div>
                              <div v-if="flagDisplayDocument" class="block-content">
                                  <div class="table-responsive">
                                      <table class="table table-striped table-vcenter">
                                          <thead>
                                              <tr>
                                                  <th style="width: 30%;">Document</th>
                                                  <th style="width: 50%;">Description</th>
                                                  <th class="text-center" style="width: 10%;">Document</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-for= "Document in DocumentTableContain">
                                                  <td class="font-w600">{{Document.Document[actualLanguage]}}</td>
                                                  <td>{{Document.Detail[actualLanguage]}}</td>
                                                  <td class="text-center">
                                                      <div class="btn-group">
                                                          <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                          @click="openDocumentInTable(Document.FileLink[actualLanguage])" title="Ouvrir/Open"><i class="fa fa-file-text"></i></button>
                                                      </div>
                                                  </td>
                                              </tr>

                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                          <!-- END Full Table -->
                    </div>


                    <div class="row push">
                      <h4 class="font-w300">{{ descriptionStepSectionTitle[actualLanguage] }}</h4>
                      <h5 class="font-w300">{{ descriptionStep01[actualLanguage] }}</h5>
                      <h5 class="font-w300">{{ descriptionStep01p1[actualLanguage] }}</h5>
                      <h5 class="font-w300">{{ descriptionStep02[actualLanguage] }}</h5>
                      <h5 class="font-w300">{{ descriptionStep03[actualLanguage] }}</h5>
                      <h5 class="font-w300">{{ descriptionStep04[actualLanguage] }}</h5>
                      <h5 class="font-w300">{{ descriptionStep05[actualLanguage] }}</h5>
                    </div>



                    <!-- ================================================================= -->
                    <!-- Section de clef d'API Master-->
                    <!-- ================================================================= -->


                    <div class="row">

                          <!-- Full Table -->
                            <div class="block block-bordered">
                                <div class="block-header bg-gray">
                                    <h3 class="block-title" @click="toggleDisplayMasterApiKey()">{{sectionLabelCreateApiMasterKey[actualLanguage]}}</h3>
                                </div>
                                <div v-if="flagDisplayMasterApiKey" class="block-content">

                                <h6 class="push">{{sectionTextCreateApiMasterKey[actualLanguage]}}</h6>
                                

                                <!-- ================================================================= -->
                                <!-- Création d'une nouvelle clef d'API-->
                                <!-- ================================================================= -->


                                <div v-if="createNewApiMasterKey===false" class="row">
                                  <div class="col-sm-12 col-md-6">
                                    <p><button  @click="openCreateNewMasterKey()" type="button" class="btn btn-success align-center" name="button">
                                      <i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelCreateApiMasterKey[actualLanguage] }}</button></p>
                                  </div>
                                </div>

                                <div v-else class="row push">

                                  <h3 class="font-w300 push-10">{{ sectionLabelCreateMasterApiKey[actualLanguage] }}</h3>
                                
                                  <div class="form-group">
                                      <div class="col-xs-12 col-md-12">
                                          <label for="register4-firstname">{{ labelApiKeyReferenceName[actualLanguage] }}</label>
                                          <input class="form-control" type="text" v-model="referenceName" placeholder="Reference">
                                      </div>
                                  </div>

                                  <div class="form-group">
                                      <div class="col-xs-12 col-md-4">
                                          <label for="register4-firstname">{{ labelTextBoxMaxCost[actualLanguage] }}</label>
                                          <input class="form-control" type="text" v-model="maximumMonthlyCost" placeholder="Adresse / Address...">
                                      </div>
                                  </div>

                                  <div class="form-group push">
                                    <div class="col-sm-12 col-md-12">
                                      <div class="col-sm-12 col-md-6">
                                        <p><button  @click="cancelCreateNewMasterKey()" type="button" class="btn btn-danger align-center" name="button">
                                          <i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelCancelCreateApiMasterKey[actualLanguage] }}</button></p>
                                      </div>

                                      <div class="col-sm-12 col-md-6">
                                        <p><button  @click="createConfirmNewMasterKey()" type="button" class="btn btn-success align-center" name="button">
                                          <i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelConfirmCreateApiMasterKey[actualLanguage] }}</button></p>
                                      </div>
                                    </div>
                                  </div>
                                </div>





                                <!-- ================================================================= -->
                                <!-- List All API sub keys-->
                                <!-- ================================================================= -->
                                <div v-if="displayMasterAPIKeysListFlag" class="row">

                                  <div class="col-xs-12"><hr></hr></div>
                                  <h4 class="font-w300">{{ labelMasterKeyList[actualLanguage] }}</h4>



                                  <div v-for ="(apiKey,index) in organizationApiKey" class="block block-bordered">
                                    <div class="block-header bg-gray-lighter">
                                        <ul class="block-options">
                                            <li>
                                                <button type="button" @click="toggleDisplayApiKey(index)"><i class="fa fa-key"></i></button>
                                            </li>
                                        </ul>
                                        <spinner size="small" v-if="organizationApiKeyIsLoagingFlag[index]"></spinner>
                                        <h6 v-else  @click="toggleDisplayApiKey(index)">{{apiKey.referenceName}}  :  {{apiKey.key}}</h6>
                                    </div>
                                    <div v-if="organizationApiKeyOpenFlag[index]" class="block-content">
                                      <div class="row push">
                                        <div class="col-xs-12 col-md-12">
                                            <label for="register4-firstname">Date Émission/Emission date : {{ organizationApiKeyData[index].emissionDate }}</label>
                                        </div>
                                        <div class="col-xs-12 col-md-12">
                                            <label for="register4-firstname">Statut/Status : {{ organizationApiKeyData[index].status }}</label>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <label for="register4-firstname">{{ labelTextBoxMaxCost[actualLanguage] }}</label>
                                            <input class="form-control" type="text" v-model="organizationApiKeyData[index].keyInfo.maximumMonthlyCost" placeholder="Adresse / Address...">
                                        </div>
                                      </div>

                                      <div class="row push">
                                        <div class="col-sm-12 col-md-6">
                                        <p><button  @click="modifyMasterKey()" type="button" class="btn btn-success align-center" name="button">
                                          <i class="fa fa-plus fa-1x push-5-r "></i>Enregistrer modifications / Save modifications</button></p>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                        <p><button  @click="deleteNewMasterKey()" type="button" class="btn btn-danger align-center" name="button">
                                          <i class="fa fa-plus fa-1x push-5-r "></i>Supprimer la clef / Delete this key</button></p>
                                        </div>

                                        <div class="col-xs-12"><hr></hr></div>
                                          <div class="col-sm-12 col-md-12 push">
                                          <h3 class="font-w300">{{ labelMasterKeyDeviceList[actualLanguage] }}</h3>
                                        </div>


                                        <div v-if="organizationApiKeyCreateDeviceFlag[index]" class="col-sm-12 col-md-12">
                                          <div class="col-xs-12 col-md-6">
                                              <label for="register4-firstname">{{ labelCreateDeviceSerialNumber[actualLanguage] }}</label>
                                              <input class="form-control" type="text" v-model="newDeviceSerialNumber" placeholder="Numero série / Sérial number">
                                          </div>
                                          <div class="col-xs-12 col-md-6 push">
                                            <label for="register4-firstname">{{ labelCreateDeviceTemplateToUse[actualLanguage] }}</label>

                                            <select class="form-control" v-model=newDeviceTemplateToUse size="1">
                                              <option v-for="Template in deviceTemplates" v-bind:value="Template.deviceTemplateId">{{Template.deviceTemplateId}}</option>
                                            </select>
                                          </div>

                                          <div class="col-xs-12 col-md-12">
                                            <div class="col-sm-12 col-md-6">
                                              <p><button  @click="confirmCreateDevice(index)" type="button" class="btn btn-success align-center" name="button">
                                                <i class="fa fa-plus fa-1x push-5-r "></i>Créer l'appareil / Create device</button></p>
                                            </div>
                                            <div class="col-sm-12 col-md-6">
                                              <p><button  @click="cancelCreateDevice(index)" type="button" class="btn btn-danger align-center" name="button">
                                                <i class="fa fa-plus fa-1x push-5-r "></i>Annuler / Cancel</button></p>
                                            </div>
                                          </div>


                                        </div>
                                        <div v-else class="col-sm-12 col-md-6">
                                          <p><button  @click="createDevice(index)" type="button" class="btn btn-success align-center" name="button">
                                            <i class="fa fa-plus fa-1x push-5-r "></i>Créer un appareil / Create device</button></p>
                                        </div>

                                        <div v-if="lastCreatedDevice.deviceId.length > 0" class="col-xs-12 col-md-12">
                                          <h4 class="font-w300 push">Appareil créé / Created device</h4>
                                          <h5 class="font-w300">Device ID: {{lastCreatedDevice.deviceId}}</h5>
                                          <h5 class="font-w300">Binding key: {{lastCreatedDevice.deviceBindingKey}}</h5>
                                          <h5 class="font-w300">API key: {{lastCreatedDevice.deviceApiKey}}</h5>
                                        </div>

                                      </div>


                                      <div class="row push">
                                        <div class="col-xs-12 col-md-12">
                                            <h4>{{labelDeviceKeyList[actualLanguage]}}</h4>

                                            <div class="table-responsive">
                                                <table class="table table-striped table-vcenter">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 15%;">Device ID</th>
                                                            <th style="width: 10%;">Binding Key</th>
                                                            <th style="width: 30%;">API key</th>
                                                            <th style="width: 15%;">Serial Number</th>
                                                            <th style="width: 30%;">Binded to</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for= "(SubKeyDetail,index) in organizationApiKeySubKeyData[index]">
                                                            <td class="font-w600">{{SubKeyDetail.linkedEntity}}</td>
                                                            <td>{{SubKeyDetail.info.bindingKey}}</td>
                                                            <td>{{SubKeyDetail.keyId}}</td>
                                                            <td>{{SubKeyDetail.info.deviceSerialNumber}}</td>
                                                            <td>{{SubKeyDetail.info.linkedProfile}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                        </div>

                                      </div>

                                    </div>
                                  </div>
                                </div>

                                </div>
                            </div>
                            <!-- END Full Table -->
                    </div>



<!-- ================================================================= -->
<!-- Section ensemble de signaux-->
<!-- ================================================================= -->
                    <div class="row">

                          <!-- Full Table -->
                            <div class="block block-bordered">
                                <div class="block-header bg-gray">
                                    <h3 class="block-title" @click="toggleDisplaySignalsSet()">{{SignalSetSectionTitle[actualLanguage]}}</h3>
                                </div>
                                <div v-if="flagDisplaySectionSignalsSet" class="block-content">


                                    <div class="row push">
                                      <div class="col-sm-12 col-md-4">
                                      <p><button  @click="createSignalsSet()" type="button" class="btn btn-success align-center" name="button">
                                        <i class="fa fa-plus fa-1x push-5-r "></i>{{labelButtonSignalsSetCreate[actualLanguage]}}</button></p>
                                      </div>

                                    </div>


                                    <div class="row push">
                                    <div class="table-responsive">
                                        <table class="table table-striped table-vcenter">
                                            <thead>
                                                <tr>
                                                    <th style="width: 90%;">{{tableLabelSignalsSetID[actualLanguage]}}</th>
                                                    <th class="text-center" style="width: 10%;">{{tableLabelSgnalsSetEdit[actualLanguage]}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for= "(Template,index) in signalsSetTemplates">
                                                    <td class="font-w600">{{Template.signalSetId}}</td>
                                                    <td class="text-center">
                                                        <div class="btn-group">
                                                            <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                            @click="editSignalSetTemplate(index)" title="Modifier/Edit"><i class="fa fa-gear"></i></button>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <!-- END Full Table -->
                    </div>










                    <!-- ================================================================= -->
                    <!-- Section Template de channel-->
                    <!-- ================================================================= -->
                    <div class="row">

                          <!-- Full Table -->
                            <div class="block block-bordered">
                                <div class="block-header bg-gray">
                                    <h3 class="block-title" @click="toggleDisplayChannelTemplate()">{{ChannelTemplateSectionTitle[actualLanguage]}}</h3>
                                </div>
                                <div v-if="flagDisplaySectionChannelTemplate" class="block-content">


                                    <div class="row push">
                                      <div class="col-sm-12 col-md-4">
                                      <p><button  @click="createChannelTemplate()" type="button" class="btn btn-success align-center" name="button">
                                        <i class="fa fa-plus fa-1x push-5-r "></i>{{labelButtonChannelTemplateCreate[actualLanguage]}}</button></p>
                                      </div>

                                      <div class="col-sm-12 col-md-4">
                                      <p><button  @click="createNewPicture('channel')" type="button" class="btn btn-success align-center" name="button">
                                        <i class="fa fa-plus fa-1x push-5-r "></i>{{labelButtonSaveNewPictureChannel[actualLanguage]}}</button></p>
                                      </div>


                                    </div>


                                    <div class="row push">
                                    <div class="table-responsive">
                                        <table class="table table-striped table-vcenter">
                                            <thead>
                                                <tr>
                                                    <th style="width: 30%;">{{tableLabelChannelTemplateID[actualLanguage]}}</th>
                                                    <th style="width: 30%;">{{tableLabelChannelTemplateName[actualLanguage]}}</th>
                                                    <th style="width: 30%;">{{tableLabelChannelTemplateType[actualLanguage]}}</th>
                                                    <th class="text-center" style="width: 10%;">{{tableLabelChannelTemplateEdit[actualLanguage]}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for= "(Template,index) in channelTemplates">
                                                    <td class="font-w600">{{Template.channelTemplateId}}</td>
                                                    <td>{{Template.channelName}}</td>
                                                    <td>{{Template.channelType}}</td>
                                                    <td class="text-center">
                                                        <div class="btn-group">
                                                            <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                            @click="editChannelTemplate(index)" title="Modifier/Edit"><i class="fa fa-gear"></i></button>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <!-- END Full Table -->
                    </div>



                    <!-- ================================================================= -->
                    <!-- Section Template de device-->
                    <!-- ================================================================= -->
                    <div class="row">

                        <!-- Full Table -->
                          <div class="block block-bordered">
                              <div class="block-header bg-gray">
                                  <h3 class="block-title" @click="toggleDisplayDeviceTemplate()">{{DeviceTemplateSectionTitle[actualLanguage]}}</h3>
                              </div>
                              <div v-if="flagDisplaySectionDeviceTemplate" class="block-content">


                                  <div class="row push">
                                    <div class="col-sm-12 col-md-6">
                                    <p><button  @click="createDeviceTemplate()" type="button" class="btn btn-success align-center" name="button">
                                      <i class="fa fa-plus fa-1x push-5-r "></i>{{labelButtonDeviceTemplateCreate[actualLanguage]}}</button></p>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                    <p><button  @click="createNewPicture('device')" type="button" class="btn btn-success align-center" name="button">
                                      <i class="fa fa-plus fa-1x push-5-r "></i>{{labelButtonSaveNewPictureDevice[actualLanguage]}}</button></p>
                                    </div>
                                  </div>



                                  <div class="row push">
                                  <div class="table-responsive">
                                      <table class="table table-striped table-vcenter">
                                          <thead>
                                              <tr>
                                                    <th style="width: 30%;">{{tableLabelChannelTemplateID[actualLanguage]}}</th>
                                                    <th style="width: 30%;">{{tableLabelChannelTemplateName[actualLanguage]}}</th>
                                                    <th style="width: 30%;">{{tableLabelChannelTemplateType[actualLanguage]}}</th>
                                                    <th class="text-center" style="width: 10%;">{{tableLabelChannelTemplateEdit[actualLanguage]}}</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                                <tr v-for= "(Template,index) in deviceTemplates">
                                                    <td class="font-w600">{{Template.deviceTemplateId}}</td>
                                                    <td>{{Template.deviceName}}</td>
                                                    <td>{{Template.deviceType}}</td>
                                                    <td class="text-center">
                                                        <div class="btn-group">
                                                            <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                            @click="editDeviceTemplate(index)" title="Modifier/Edit"><i class="fa fa-gear"></i></button>
                                                        </div>
                                                    </td>
                                                </tr>

                                          </tbody>
                                      </table>
                                  </div>
                                  </div>
                              </div>
                          </div>
                          <!-- END Full Table -->
                    </div>




                
                </div>
              </div>

        </div>
    </div>


  </div>
</template>

<script>

import _ from 'underscore'
import { mapState, mapActions } from 'vuex'
import Spinner from '@/components/Spinner.vue'

//See:https://codingshiksha.com/vue/vue-js-pdf-generator-in-vuetify-ui-using-jspdf-and-jspdf-autotable-library-full-tutorial-for-beginners/
//import jsPDF from 'jspdf'


export default {
  props: ['organizationData'],

  components: {
    Spinner,
   },


  data() {
    return {
      
      actualLanguage : "FR",
      labelFreeService: {FR: 'Service gratuit', EN: 'Free service'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

      signalsSetTemplates : [],
      channelTemplates : [],
      deviceTemplates : [],

      sectionLabelApiManagement:{FR: "Gestion API", EN: 'API Management'},
      flagDisplaySectionApi : 0,
      displayMasterAPIKeysListFlag:true,
      organizationApiKey : [],
      organizationApiKeyData : [],
      organizationApiKeySubKeyData : [],
      organizationApiKeyOpenFlag : [],
      organizationApiKeyIsLoagingFlag:[],
      organizationApiKeyCreateDeviceFlag : [],

      descriptionStepSectionTitle : {FR: "Étapes à suivre:", EN: 'Steps to follow:'},
      descriptionStep01 : {FR: "1) Créer une clef d'API maître (section GESTION DES CLEF D'API).",
                           EN: '1) Create a master API key (section MANAGE API KEYS).'},
      descriptionStep01p1 : {FR: "2) Créer un ensemble de signaux et de paramètres du système mesuré.",
                           EN: '2) Create signal set for your system.'},                           
      descriptionStep02 : {FR: "3) Créer un gabarit d'affichage (section GABARIT D'AFFICHAGE DES APPAREILS). ",
                           EN: '3) Create device display template (section CREATE CHANNEL DISPLAY TEMPLATE).'},
      descriptionStep03 : {FR: "4) Créer un gabarit d'appareil de mesure (section GABARIT D'APPAREILS DE MESURE).",
                           EN: '4) Create a measurement device template (section MEASUREMENT DEVICE TEMPLATES).'},
      descriptionStep04 : {FR: "5) Chaque appareil de mesure qui sont produit doivent avoir une clef d'API ainsi qu'un identifiant d'appareil (device_id), vous devez donc créer une clef d'API d'appareil sous une clef maître d'API (section GESTION DES CLEF D'API).",
                           EN: '5) Each measuring device that is produced must have an API key as well as a device identifier (device_id), create a device API key under a master API key (section MANAGE API KEYS).'},
      descriptionStep05 : {FR: "6) Utiliser les informations de l'API d'appareils pour la préparation de votre unitée produite.",
                           EN: '6) Use the API key informations to prepare to produce unit.'},

      flagDisplayDocument : 0,
      DocumentTableTitle : {FR: 'Documentation', EN: 'Documentation'},

      DocumentTableContain:[{Document:{FR:"Guide utilisation API",EN:"API User guide"},
                            Detail:{FR:"Explication de fonctionnement et guide de programmation.",
                                    EN:"Functionality description and programming guide."},
                            FileLink:{FR:"https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf",
                                      EN:"https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf"}},

                            {Document:{FR:"Coût d'utilisation de l'API",EN:"API pricing fees"},
                            Detail:{FR:"Détails des coûts d'utilisation de l'API.",
                                    EN:"Pricing detail."},
                            FileLink:{FR:"https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Installation_EVA_V2_ENFR_V1P03.pdf",
                                      EN:"https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Installation_EVA_V2_ENFR_V1P03.pdf"}},

                                      ],


      flagDisplaySectionSignalsSet : 0,
      SignalSetSectionTitle: {FR: "Ensembles de signaux et de paramètres", EN: 'Signals and parameters sets'},
      labelButtonSignalsSetCreate: {FR: "Créer un ensemble", EN: 'Create set'},
      tableLabelSignalsSetID: {FR: "Identifiant (ID)", EN: 'Identifier (ID)'},
      tableLabelSgnalsSetEdit: {FR: "Modifier", EN: 'Edit'},



      ChannelTemplateSectionTitle : {FR: "Gabarit d'affichage des appareils (channel)", EN: 'Device display templates'},
      labelButtonChannelTemplateCreate: {FR: "Créer un gabarit d'affichage d'appareil", EN: 'Create channel display template'},
      labelButtonSaveNewPictureChannel: {FR: "Enregistrer une nouvelle image d'appareil", EN: 'Save new device picture'},
      labelButtonSaveNewPictureDevice: {FR: "Enregistrer une nouvelle image d'appareil de mesure", EN: 'Save new measurement device picture'},
      tableLabelChannelTemplateID: {FR: "Identifiant (ID)", EN: 'Identifier (ID)'},
      tableLabelChannelTemplateName: {FR: "Nom du gabarit", EN: 'Template name'},
      tableLabelChannelTemplateType: {FR: "Type de gabarit", EN: 'Template type'},
      tableLabelChannelTemplateEdit: {FR: "Modifier", EN: 'Edit'},
      flagDisplaySectionChannelTemplate : 0,

      DeviceTemplateSectionTitle : {FR: "Gabarit d'appareils de mesure (device)", EN: 'Measurement device templates'},
      labelButtonDeviceTemplateCreate: {FR: "Créer un gabarit d'appareil de mesure", EN: 'Create measurement device template'},
      flagDisplaySectionDeviceTemplate : 0,


      flagDisplayMasterApiKey : 0,
      sectionLabelCreateApiMasterKey : {FR: "Gestion des clef d'API (Création d'appareils)", EN: 'Manage API keys (Devices creation)'},
      sectionTextCreateApiMasterKey : {FR: "Les clef d'API maître permettent de créer des sous clef d'appareils. Les clef d'appareils sont utilisés par les appareils de mesure pour transmettre des données vers le cloud EV Sens. Si une clef maître est désactivée, toutes les sous clef deviendront inactives. Il est possible de régler une limite de frais mensuel par clef maître. Ainsi si la sommes des frais des sous-clef atteigne le maximum, celles-si seront temporairement inactivées. POUR PLUS D'INFORMATION SE RÉFÉRER A LA SECTION DOCUMENTATION CI-HAUT.",
                                       EN: 'Master API keys are used to create device sub-keys. Device keys are used by measuring devices to transmit data to the EV Sens cloud. If a master key is deactivated, all the sub-keys will become inactive. It is possible to set a monthly fee limit per master key. So if the sum of the costs of the sub-keys reaches the maximum, they will be temporarily inactivated. FOR MORE INFORMATION, REFER TO THE DOCUMENTATION SECTION ABOVE.'},
      buttonLabelCreateApiMasterKey : {FR: "Créer une clef d'API maître", EN: 'Create API Master Key'},
      buttonLabelCancelCreateApiMasterKey : {FR: "Annuler", EN: 'Cancel'},
      buttonLabelConfirmCreateApiMasterKey : {FR: "Confirmer", EN: 'Confirm'},

      sectionLabelCreateMasterApiKey:{FR: "Création clef d'API maître", EN: 'Create API master key'},
      createNewApiMasterKey : false,
      labelApiKeyReferenceName:{FR: "Nom de référence de la clef", EN: 'Key reference name'},
      referenceName : "",
      labelTextBoxMaxCost:{FR: "Limite coût mensuel", EN: 'Maximum monthly cost'},     
      maximumMonthlyCost:"50",

      labelMasterKeyList :{FR: "Clefs maître", EN: 'Master keys'},
      labelMasterKeyDeviceList : {FR: "Appareils", EN: 'Devices'},

      labelCreateDeviceSerialNumber :{FR: "Numéro de série de l'appareil", EN: 'Device serial number'},
      newDeviceSerialNumber : "",
      labelCreateDeviceTemplateToUse :{FR: "Template d'appareil", EN: 'Device template'},
      newDeviceTemplateToUse : "",

      lastCreatedDevice : {deviceId:"",deviceBindingKey:"",deviceApiKey:""},

      labelDeviceKeyList: {FR: "Appareils créés sous cette clef maître:", EN: 'Device list created under this master key:'},

    }
  },

  computed: {
    ...mapState('sessionStore', ['planTransactionData']),
    ...mapState('sessionStore', ['userEmail','profileData']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayApi(){
      this.flagDisplaySectionApi=~this.flagDisplaySectionApi
    },

   toggleDisplayDocument(){
      this.flagDisplayDocument=~this.flagDisplayDocument
    },    


    toggleDisplaySignalsSet(){
      this.flagDisplaySectionSignalsSet =~ this.flagDisplaySectionSignalsSet
    },


    toggleDisplayChannelTemplate(){
      this.getChannelTemplateList()
      this.flagDisplaySectionChannelTemplate =~ this.flagDisplaySectionChannelTemplate
    },

    toggleDisplayDeviceTemplate(){
      this.getDeviceTemplateList()
      this.flagDisplaySectionDeviceTemplate =~ this.flagDisplaySectionDeviceTemplate
    },

    openDocumentInTable(FileLink) {
      var localUrl ='';
      window.open(FileLink, '_blank');  
    },     


    //----------------------------------------------------------------
    //----------------------------------------------------------------
    //Create API Master Keys functions
    //----------------------------------------------------------------
    //----------------------------------------------------------------
    toggleDisplayMasterApiKey(){
      this.flagDisplayMasterApiKey =~this.flagDisplayMasterApiKey
    },

    openCreateNewMasterKey(){
      this.createNewApiMasterKey = true
      this.displayMasterAPIKeysListFlag = false
    },
    cancelCreateNewMasterKey(){
      this.createNewApiMasterKey = false
      this.displayMasterAPIKeysListFlag = true
    },


    createConfirmNewMasterKey(){

        if(this.referenceName.length > 0){
            var requestData = { 'postAction':'CreateNewOrganizationMasterKey',
                                'organizationId': this.organizationData.organizationId,
                                'referenceName':this.referenceName,
                                'maximumMonthlyCost':this.maximumMonthlyCost
                              }

            this.$store.dispatch('sessionStore/postOrganization', requestData)
                .then((response) => {
                  //console.log(response.data)
                  //this.keyIsCreating = false
                if(response.data.Code=='OK'){
                    //this.createNewApiMasterKey = false
                    this.organizationApiKey.push(response.data.CreatedKey)
                    this.organizationApiKeySubKeyData.push({TBD:"TBD"})
                    this.organizationApiKeyCreateDeviceFlag.push(false)
                    this.organizationApiKeyIsLoagingFlag.push(false)
                    this.displayMasterAPIKeysListFlag = true
                    }
                    else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                })  

          this.createNewApiMasterKey = false
      }else{
        var ErrorMessage = {FR:"Le nom de référence est vide!",EN:"The reference name is empty!"}
        window.alert(ErrorMessage[this.actualLanguage])
      }
    },



    getChannelTemplateList(){
      this.channelTemplates = []
        var requestData = { 'postAction':'GetOrganizationChannelTemplates',
                            'organizationId': this.organizationData.organizationId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Get Channel List-----')
              //console.log(response.data)
              //this.keyIsCreating = false
              
            if(response.data.Code=='OK'){
                //this.createNewApiMasterKey = false
                this.channelTemplates = response.data.ChannelTemplates
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },


    getSignalSetList(){
      this.channelTemplates = []
        var requestData = { 'postAction':'GetOrganizationSignalsSet',
                            'organizationId': this.organizationData.organizationId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Get Channel List-----')
              //console.log(response.data)
              //this.keyIsCreating = false
              
            if(response.data.Code=='OK'){
                //this.createNewApiMasterKey = false
                this.signalsSetTemplates = response.data.SignalsSets
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },



    createSignalsSet(){
      var modalParameters = {
                  'organizationId':this.organizationData.organizationId,
                  'organizationApiKeys':this.organizationApiKey,
                  'action':'create',
                        }
      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('organization-api-signals-set-add-form')  
    },


    createChannelTemplate(){
      var modalParameters = {
                  'organizationId':this.organizationData.organizationId,
                  'organizationApiKeys':this.organizationApiKey,
                  'action':'create',
                        }
                        
      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('organization-api-channel-template-add-form')  

    },

    createNewPicture(pictureType){
      var modalParameters = {
                  'organizationId':this.organizationData.organizationId,
                  'pictureType':pictureType,
                        }
                        
      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('organization-api-add-picture-form')  

    },


    editSignalSetTemplate(index){
      var modalParameters = {
            'organizationId':this.organizationData.organizationId,
            'organizationApiKeys':this.organizationApiKey,
            'action':'edit',
            'templateId':this.signalsSetTemplates[index].signalSetId,
                  }
                        
      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('organization-api-signals-set-add-form')  
      //window.alert("Non disponible / Not available")
    },


    editChannelTemplate(index){
      var modalParameters = {
            'organizationId':this.organizationData.organizationId,
            'organizationApiKeys':this.organizationApiKey,
            'action':'edit',
            'templateId':this.channelTemplates[index].channelTemplateId,
                  }
                        
      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('organization-api-channel-template-add-form')  
      //window.alert("Non disponible / Not available")
    },





    getDeviceTemplateList(){
      this.deviceTemplates = []
        var requestData = { 'postAction':'GetOrganizationDeviceTemplates',
                            'organizationId': this.organizationData.organizationId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Get device List-----')
              //console.log(response.data)
              //this.keyIsCreating = false
              
            if(response.data.Code=='OK'){
                //this.createNewApiMasterKey = false
                this.deviceTemplates = response.data.DeviceTemplates
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },


    createDeviceTemplate(){
      var modalParameters = {
                  'organizationId':this.organizationData.organizationId,
                  'organizationApiKeys':this.organizationApiKey,
                  'action':'create',
                        }
                        
      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('organization-api-device-template-add-form')  
    },



    editDeviceTemplate(index){
      var modalParameters = {
            'organizationId':this.organizationData.organizationId,
            'organizationApiKeys':this.organizationApiKey,
            'action':'edit',
            'templateId':this.deviceTemplates[index].deviceTemplateId,
                  }
                        
      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('organization-api-device-template-add-form')  
      //window.alert("Non disponible / Not available")
    },



    //----------------------------------------------------------------
    //----------------------------------------------------------------
    //Manage and display API Key
    //----------------------------------------------------------------
    //----------------------------------------------------------------

    toggleDisplayApiKey(index){
      //this.flagDisplaySectionApi=0
      this.lastCreatedDevice = {deviceId:"",deviceBindingKey:"",deviceApiKey:""},
      this.newDeviceSerialNumber = ""
      this.newDeviceTemplateToUse = ""

      this.organizationApiKeyIsLoagingFlag[index] = true
      this.displayMasterAPIKeysListFlag = false
      this.$nextTick(() => {this.displayMasterAPIKeysListFlag = true});

      //Reading of the key informations
        var requestData = { 'postAction':'ReadKeyDetails',
                            'organizationId': this.organizationData.organizationId,
                            'keyId': this.organizationApiKey[index].key,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log(response.data)
            if(response.data.Code=='OK'){
                this.organizationApiKeyData[index] = response.data.KeyData
                this.organizationApiKeyOpenFlag[index]=~this.organizationApiKeyOpenFlag[index]
                //this.flagDisplaySectionApi=-1
                this.organizationApiKeyIsLoagingFlag[index] = false
                this.displayMasterAPIKeysListFlag = false
                this.$nextTick(() => {this.displayMasterAPIKeysListFlag = true});
                
                this.readSubKeyDetails(index)

                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            }) 
    },

    createDevice(index){
      this.displayMasterAPIKeysListFlag = false
      this.organizationApiKeyCreateDeviceFlag[index]=true
      this.$nextTick(() => {this.displayMasterAPIKeysListFlag = true});

    },

    cancelCreateDevice(index){
      this.displayMasterAPIKeysListFlag = false
      this.organizationApiKeyCreateDeviceFlag[index]=false
      this.$nextTick(() => {this.displayMasterAPIKeysListFlag = true});
    },

    confirmCreateDevice(index){

      if(this.newDeviceSerialNumber.length == 0 | this.newDeviceTemplateToUse.length == 0){
        var ErrorMessage = {FR:"Le numéro de série ou le template est vide!",EN:"The serial number or template is empty!"}
        window.alert(ErrorMessage[this.actualLanguage])
      }else{


          var postBody = {
            'postAction':'createNewDevice',
            'organization_id':this.organizationData.organizationId.substring(5,20),
            'template_id':this.newDeviceTemplateToUse,
            'serialNumber':this.newDeviceSerialNumber,
          }

          var requestData = { 'postAction':'ApiCustomerGateway',
                              'organizationId': this.organizationData.organizationId,
                              'organizationApiKey': this.organizationApiKey[index].key,
                              'postBody':postBody ,
                            }

          this.$store.dispatch('sessionStore/postOrganization', requestData)
              .then((response) => {
                //console.log('------Create device response----------')
                //console.log(response.data)
              if(response.data.Code=='OK'){
                  var Message = {FR:"Votre appareil de mesure a été créé dans le système!",EN:"Your measurement device was created in the system!"}
                  window.alert(Message[this.actualLanguage])
                  //this.$store.dispatch('sessionStore/refreshProfileData')
                  //this.$store.dispatch('overlayStore/toggleModal',false)

                  this.lastCreatedDevice.deviceId = response.data.CallResponse.deviceInfo.deviceId
                  this.lastCreatedDevice.deviceBindingKey = response.data.CallResponse.deviceInfo.deviceBindingKey
                  this.lastCreatedDevice.deviceApiKey = response.data.CallResponse.deviceInfo.deviceApiKey

                  this.cancelCreateDevice(index)
                  this.readSubKeyDetails(index)
                  }
                  else{ window.alert(response.data.CallResponse.message)}
              }) 
      }
    },


    readSubKeyDetails(index){

      var postBody = {
        'postAction':'readSubKeysDetails',
        'organization_id':this.organizationData.organizationId.substring(5,20),
        'masterKeyId':this.organizationApiKey[index].key,
      }

      var requestData = { 'postAction':'ApiCustomerGateway',
                          'organizationId': this.organizationData.organizationId,
                          'organizationApiKey': this.organizationApiKey[index].key,
                          'postBody':postBody ,
                        }

      this.$store.dispatch('sessionStore/postOrganization', requestData)
          .then((response) => {
            //console.log('------Read List of sub keys----------')
            //console.log(response.data)
          if(response.data.Code=='OK'){
              this.organizationApiKeySubKeyData[index] = response.data.CallResponse.subKeysDetail
              this.displayMasterAPIKeysListFlag = false
              this.$nextTick(() => {this.displayMasterAPIKeysListFlag = true});
              }
              else{ window.alert(response.data.CallResponse.message)}
          }) 
    },

  
  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.organizationApiKey = this.organizationData.apiManagement.apiOrganizationKeys
    this.organizationApiKeyOpenFlag = []
    this.organizationApiKeyCreateDeviceFlag = []
    for(var m = 0;m < this.organizationApiKey.length;m++){
      this.organizationApiKeyOpenFlag.push(0)
      this.organizationApiKeyCreateDeviceFlag.push(false)
      this.organizationApiKeyIsLoagingFlag.push(false)
      this.organizationApiKeyData.push({TBD:'TBD'})
      this.organizationApiKeySubKeyData.push({TBD:"TBD"})
      }

    this.getChannelTemplateList()
    this.getDeviceTemplateList()
    this.getSignalSetList()

    //this.getTransactionHistory()

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// OrganizationApiManagement.vue?3f65faad